import React from 'react';
import PropTypes from 'prop-types';
import { getColor } from 'core/utils/Styles';

const ChatBubble = ({ stroke, ...props }) => (
	<svg width="1em" height="1em" viewBox="0 0 18 16" stroke={stroke} {...props}>
		<path
			d="M9 15C13.4183 15 17 11.866 17 8C17 4.13401 13.4183 1 9 1C4.58172 1 1 4.13401 1 8C1 9.37749 1.45472 10.6621 2.23999 11.745L1 15L5.21748 14.1697C6.34375 14.6994 7.63176 15 9 15Z"
			fill="none"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

ChatBubble.propTypes = {
	stroke: PropTypes.string,
};

ChatBubble.defaultProps = {
	stroke: getColor('gray5'),
};

export default ChatBubble;
